export const TOOLBAR_CONFIG = {
  ENABLED_LOCATION_FINDER: 'locationFinder',
  ENABLED_GRID_SQUARE_LAYER: 'gridSquareLayer',
  ENABLED_ZOOM_TO_EXTENT: 'zoomToExtent',
  NAVIGATION_HISTORY_INSTANCE: 'navigationHistoryInstance',
} as const;

export const ACTIONS = {
  MAP: {
    // workbook map view, fullscreen map dialogs
    ENABLED_LOCATION_FINDER: TOOLBAR_CONFIG.ENABLED_LOCATION_FINDER,
    ENABLED_ZOOM_TO_EXTENT: TOOLBAR_CONFIG.ENABLED_ZOOM_TO_EXTENT,
    ZOOM_IN: 'zoomIn',
    ZOOM_OUT: 'zoomOut',
    DRAG_ZOOM: 'dragZoom',
    UNDO: 'undo',
    REDO: 'redo',
    WORKBOOK_PRINT_MAP: 'workbookPrintMap',

    // 3d
    TIMELINE_3D_FILTER: 'timeline3DFilter',
    TIMELINE_3D_VIEW_FROM_SOUTH: 'timeline3DViewFromSouth',
    TIMELINE_3D_VIEW_FROM_WEST: 'timeline3DViewFromWest',
    TIMELINE_3D_VIEW_FROM_NORTH: 'timeline3DViewFromNorth',
    TIMELINE_3D_VIEW_FROM_EAST: 'timeline3DViewFromEast',
    TIMELINE_3D_VIEW_FROM_TOP: 'timeline3DViewFromTop',
    TIMELINE_3D_ORTOHRAPHIC_CAMERA: 'timeline3DOrtographicCamera',
    TIMELINE_3D_PERSPECTIVE_CAMERA: 'timeline3DPerspectiveCamera',
    TIMELINE_3D_RESET_CAMERA: 'timeline3DResetCamera',
    TIMELINE_3D_TOGGLE_BOX: 'timeline3DToggleBox',
    TIMELINE_3D_TOGGLE_MAP: 'timeline3DToggleMap',
    TIMELINE_3D_TOGGLE_FLOATING_MAP: 'timeline3DToggleFloatingMap',
    WORKBOOK_TIMELINE_3D_GO_TO_2D: 'workbookTimeline3DGoTo2D',

    // sketch layer editing toolbar
    SKETCH_SELECT: 'sketchSelect',
    SKETCH_BRING_TO_FRONT: 'sketchBringToFront',
    SKETCH_SEND_TO_BACK: 'sketchSendToBack',
    SKETCH_GROUP: 'sketchGroup',
    SKETCH_UNDO: 'sketchUndo',
    SKETCH_REDO: 'sketchRedo',
    WORKBOOK_CREATE_SKETCH: 'workbookCreateSketch',
  },
} as const;
